export const PAYMENT_ACTIONS = {
  new: 'new',
  renew: 'renew',
  upgrade: 'upgrade',
  downgrade: 'downgrade',
};
